import { Col, Row, Space, Typography } from "antd";
import { useParams } from "react-router-dom";
import { useGetFavoriteAdvertList } from "../Ads/ServerSideStates";
import SkeletonCard from "apps/Common/Skelton/AdvertCardSkelton";
import React from "react";
import RealStateCardViewItem from "apps/RealState/Common/CardViewIem";

const SharedFavoriteListDetails = () => {
    const {Text} = Typography
    const params = useParams()
    const listId = params["listId"]
      const favoriteAdverts = useGetFavoriteAdvertList(listId||"");
    return (<>
    <Col xs={24} >
        <Row className="!px-16">
        <Col span={24} className="!flex justify-center mb-5">
            <Text className="">
              <Space>
                <span className="!text-2xl !font-bol">Paylaşılan FavoriListesi</span>
                <span className="!text-gray-400">
                  ({favoriteAdverts?.data?.data?.favorite.length || 0} Adet)
                </span>
              </Space>
            </Text>
          </Col>
          <Col xs={24}>
            <Row gutter={[40, 40]}>
              <SkeletonCard
                count={4}
                customGutter={[40, 40]}
                loading={
                  favoriteAdverts.isLoading || favoriteAdverts.isFetching
                }
              >
                <>
                  {
                    favoriteAdverts?.data?.data?.favorite?
                    favoriteAdverts?.data?.data?.favorite.map(
                      (item: any, index: number) => {
                        return (
                          <React.Fragment key={index}>
                            <Col
                              xs={24}
                              md={12}
                              lg={6}
                              className="hover:cursor-pointer"
                            >
                              <RealStateCardViewItem
                                item={item?.advert}
                                mainItem={item}
                                pageType="favorite"
                                advertType={
                                  item?.advert?.type === 0 ? "realState" : "vehicle"
                                }
                              />
                            </Col>
                          </React.Fragment>
                        );
                      }
                    ):[]
                  }
                </>
              </SkeletonCard>
            </Row>
          </Col>
        </Row>
    </Col>
    </>  );
}
 
export default SharedFavoriteListDetails;